import createTypedReducer from "@insite/client-framework/Common/CreateTypedReducer";
import { SystemList } from "@tggstore/Services/CommonServices";
import { Draft } from "immer";

export interface SystemListStateType {
    readonly isLoading: boolean;
    readonly systemList: SystemList | null;
    readonly errorMessage: string;
}

export type SystemListState = Readonly<SystemListStateType>;

export const initialBlogState: SystemListState = {
    isLoading: false,
    systemList: null,
    errorMessage: "",
};

export const customSystemListReducer = createTypedReducer(initialBlogState, {
    "Custom/SystemListState/Loading": (draft: Draft<SystemListState>, { isLoading }: { isLoading: boolean }) => ({
        ...draft,
        isLoading,
    }),

    "Custom/SystemListState/CompletedLoadSystemList": (
        draft: Draft<SystemListState>,
        { systemList }: { systemList: SystemList },
    ) => ({
        ...draft,
        systemList,
    }),

    "Custom/SystemListState/FailedToLoad": (draft: Draft<SystemListState>, { message }: { message: string }) => ({
        ...draft,
        isLoading: false,
        errorMessage: message,
    }),
});
